import _extends from "@babel/runtime/helpers/extends";
import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { Checkbox } from '@atlaskit/checkbox';
import { CheckboxField } from '@atlaskit/form';
import React from 'react';

const DaysContainer = _styled("div", {
  target: "e1k238dn0",
  label: "DaysContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1y6e8q",
  styles: "margin-left:30px;"
} : {
  name: "1y6e8q",
  styles: "margin-left:30px;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

const CustomDaysSelection = ({
  days
}) => {
  const dayMap = {};

  if (days) {
    days.forEach(day => {
      dayMap[day] = true;
    });
  }

  const checkboxFields = [{
    value: 'monday',
    defaultIsChecked: !!dayMap.monday,
    label: 'Monday'
  }, {
    value: 'tuesday',
    defaultIsChecked: !!dayMap.tuesday,
    label: 'Tuesday'
  }, {
    value: 'wednesday',
    defaultIsChecked: !!dayMap.wednesday,
    label: 'Wednesday'
  }, {
    value: 'thursday',
    defaultIsChecked: !!dayMap.thursday,
    label: 'Thursday'
  }, {
    value: 'friday',
    defaultIsChecked: !!dayMap.friday,
    label: 'Friday'
  }, {
    value: 'saturday',
    defaultIsChecked: !!dayMap.saturday,
    label: 'Saturday'
  }, {
    value: 'sunday',
    defaultIsChecked: !!dayMap.sunday,
    label: 'Sunday'
  }];
  return /*#__PURE__*/React.createElement(DaysContainer, null, checkboxFields.map(({
    value,
    defaultIsChecked,
    label
  }) => /*#__PURE__*/React.createElement(CheckboxField, {
    name: "days",
    value: value,
    defaultIsChecked: defaultIsChecked,
    key: value
  }, ({
    fieldProps
  }) => /*#__PURE__*/React.createElement(Checkbox, _extends({}, fieldProps, {
    label: label
  })))));
};

export default CustomDaysSelection;